import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {CUSTOMER_TYPES} from '../../../services/constant';
import {CustomerListComponent} from '../customer-list/customer-list.component';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import * as validate from 'validate.js';


@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.scss']
})
export class CustomerDetailComponent implements OnInit {
  modal: NgbModalRef;
  parent: CustomerListComponent = null;

  countryList: any[];
  branchCodeList: any[];
  customerTypes = CUSTOMER_TYPES.map(obj => ({label: obj.name, value: obj.value}));

  data = {
    id: null,
    buyerType: null,
    name: '',
    customerID: '',
    taxID: '',
    branchName: '',
    branchCode: [],
    headOffice: false,
    address: '',
    postCode: '',
    country: null,
    phoneNumber: '',
    email: ''
  };
  isCreate = true;

  errors: any;
  errorTaxID: any;

  constraints = {
    general: {
      buyerType: {
        presence: true
      },

      name: {
        presence: {allowEmpty: false}
      },

      headOffice: {
        presence: true
      },

      branchName: function (value, attributes, attributeName, options, constraints) {
        if (attributes.headOffice === false) {
          return {
            presence: {allowEmpty: true}
          };
        }
        return null;
      },

      address: {
        presence: {allowEmpty: false}
      },

      postCode: {
        presence: {allowEmpty: false}
      },
    },

    foreign: {
      country: {
        presence: true
      },

      taxID: {
        presence: {
          message: '^Passport number can\'t be blank'
        },
        numericality: {
          onlyInteger: true,
          message: '^Passport number is not a valid number'
        }
      },
    },

    domestic: {
      branchCode: {
        presence: true
      },
    },

    notForeign: {
      taxID: {
        presence: true,
        numericality: {onlyInteger: true},
        length: {is: 13}
      },
    }
  };

  @ViewChild('modalTemplate') modalTemplate: TemplateRef<any>;

  constructor(private apiService: ApiService,
              private modalService: NgbModal) {
  }

  open(parent: CustomerListComponent, buyerType, buyer) {
    this.parent = parent;
    this.data.buyerType = buyerType.value;

    if (buyer) {
      this.isCreate = false;
      Object.assign(this.data, {
        id: buyer.id,
        // buyerType: buyer.buyer_type,
        name: buyer.name,
        customerID: buyer.customer_id,
        taxID: buyer.tax_id,
        address: buyer.address,
        branchCode: buyer.branch_code,
        country: buyer.country_code,
        postCode: buyer.post_code,
        phoneNumber: buyer.phone_number,
        email: buyer.email
      });
    }
    this.modal = this.modalService.open(this.modalTemplate, {size: 'lg'});
  }

  ngOnInit() {
    this.loadCountry();
  }

  get isForeignCorporation() {
    return this.data.buyerType === 1;
  }

  get isDomesticCorporation() {
    return [0, 3].indexOf(this.data.buyerType) !== -1;
  }

  loadCountry() {
    this.apiService.getCountry().subscribe(
      (res: any) => {
        this.countryList = res.map(obj => ({
          label: obj.country_name,
          value: obj.country_code
        }));
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  validate() {
    const buyerConstraints = validate.extend({}, this.constraints.general);
    if (this.isForeignCorporation) {
      validate.extend(buyerConstraints, this.constraints.foreign);
    }
    if (this.isDomesticCorporation) {
      validate.extend(buyerConstraints, this.constraints.domestic);
    }
    if (this.data.taxID) {
      if (this.data.taxID.length === 13) {
        this.errorTaxID = null;
      } else if ((typeof (this.data.taxID)) === 'object') {
        this.errorTaxID = null;
      } else {
        this.errorTaxID = 'Buyer Taxi ID should be 13 digits or blank';
      }
    } else {
      this.data.taxID = null;
    }
    this.errors = validate(this.data, buyerConstraints);
  }

  submit() {
    this.errorTaxID = null;
    this.errors = null;
    this.validate();
    if (this.errors || this.errorTaxID) {
      return;
    }

    const data = {
      name: this.data.name,
      customer_id: this.data.customerID,
      tax_id: this.data.taxID,
      address: this.data.address,
      branch_code: this.data.branchCode.toString(),
      post_code: this.data.postCode,
      country_code: this.data.country,
      email: this.data.email,
      buyer_type: this.data.buyerType
    };

    // data depended on customer type
    if (this.isForeignCorporation) {
      data['country_code'] = this.data.country;
    }
    if (this.isDomesticCorporation) {
      data['branchCode'] = this.data.branchCode.toString();
    }

    // get API by operation
    let api = null;
    if (this.isCreate) {
      api = this.apiService.createBuyerBranch(data);
    } else {
      api = this.apiService.updateBuyerBranch(this.data.id, data);
    }

    api.subscribe(
      () => {
        this.modal.close();
        this.sniff('UPDATE_CUST_DATA', '');
        this.parent.loadData();
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'CUS_INFO',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer-detail/customer-detail.component.ts